/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Magnified_Close_LabelInputs */

const en_image_export_magnified_close_label = /** @type {(inputs: Image_Export_Magnified_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close magnified preview`)
};

const fr_image_export_magnified_close_label = /** @type {(inputs: Image_Export_Magnified_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la previsualisation agrandie`)
};

const de_image_export_magnified_close_label = /** @type {(inputs: Image_Export_Magnified_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergrößerte Vorschau schließen`)
};

const it_image_export_magnified_close_label = /** @type {(inputs: Image_Export_Magnified_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi anteprima ingrandita`)
};

const ru_image_export_magnified_close_label = /** @type {(inputs: Image_Export_Magnified_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увеличенный фрагмент предварительного просмотра`)
};

const es_image_export_magnified_close_label = /** @type {(inputs: Image_Export_Magnified_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar vista ampliada`)
};

const zh_cn2_image_export_magnified_close_label = /** @type {(inputs: Image_Export_Magnified_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭放大预览`)
};

const ja_image_export_magnified_close_label = /** @type {(inputs: Image_Export_Magnified_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拡大プレビューを閉じる`)
};

const hi_image_export_magnified_close_label = /** @type {(inputs: Image_Export_Magnified_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ज़ूम करके देखने का पूर्वावलोकन`)
};

const pt_pt2_image_export_magnified_close_label = /** @type {(inputs: Image_Export_Magnified_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização ampliada aproximada`)
};

/**
* | output |
* | --- |
* | "Close magnified preview" |
*
* @param {Image_Export_Magnified_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_magnified_close_label = /** @type {((inputs?: Image_Export_Magnified_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Magnified_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_magnified_close_label(inputs)
	if (locale === "de") return de_image_export_magnified_close_label(inputs)
	if (locale === "it") return it_image_export_magnified_close_label(inputs)
	if (locale === "ru") return ru_image_export_magnified_close_label(inputs)
	if (locale === "es") return es_image_export_magnified_close_label(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_magnified_close_label(inputs)
	if (locale === "ja") return ja_image_export_magnified_close_label(inputs)
	if (locale === "hi") return hi_image_export_magnified_close_label(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_magnified_close_label(inputs)
	return en_image_export_magnified_close_label(inputs)
});